import PropTypes from "prop-types";
import React, { useState } from "react";
const CheckoutStepbar = ({ PhaseList, PhaseNum }) => {
  return (
    <div className="CheckoutStepbar">
    <div className="make__phase">
      {PhaseList.map((i, key) => (
        <div key={key}>
          <div
            className="make__phase--box"
            data-tut={
              key === 0
                ? "reactour__start"
                : key === 1
                ? "reactour__secondphaze"
                : key === 2
                ? "reactour__Thirdphaze"
                : "reactour__Forthphaze"
            }
          >
            <div  className={`${PhaseNum === i.PhaseNumber ? "make__phase--box-num--active" :""} make__phase--box-num`}><p>{i.PhaseNumber}</p></div>
            <p
             className="make__phase--box--name"
            >
              {i.phaseName}
            </p>
            <div
              className={`${PhaseNum === i.PhaseNumber ? "make__phase-circle--activate" :""} make__phase-circle`}
             
            ></div>
          </div>
          <div
            className="make__phase-line "
            style={PhaseNum > i.PhaseNumber ? { borderColor: "#ff9400" } : null}
          >
          
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};


export default CheckoutStepbar;

